/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelectOneGhost from 'DesignSystem/TysiaSelectOneGhost/index'
import TysiaSelectOneGhostArrow from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostArrow/index'
import TysiaSelectOneGhostContent from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostContent/index'
import TysiaSelectOneGhostIcon from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostIcon/index'
import TysiaSelectOneGhostLabel from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import Tysiav2Workflows from 'DesignSystem/Svgs/Tysiav2Workflows/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CreateProcedureReceivables/NewTask/Content/Board/Content",
  onChange
  
}) {
let eventActionDataNewTaskBoardIdValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.new_task.board_id',
})
let eventActionDataNewTaskBoardIdChangeData = fromData.useDataChange({ viewPath,
context: 'event_action',
path: 'data.new_task.board_id',
})
let boardsValueData = fromData.useDataValue({ viewPath,
context: 'boards',
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaSelectOneGhost
  viewPath={`${viewPath}/TysiaSelectOneGhost`}
 placeholder="Board"
 required={true}
 data="event_action.data.new_task.board_id"
 value={eventActionDataNewTaskBoardIdValueData}
 onChange={eventActionDataNewTaskBoardIdChangeData}
 data="boards"
 from={boardsValueData}
 keepFilter={true}
>
{childProps => (
<TysiaSelectOneGhostContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneGhostIcon
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostIcon`}
>
{childProps => (
<Tysiav2Workflows
{...childProps}
  viewPath={`${viewPath}/Tysiav2Workflows`}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaSelectOneGhostIcon>
<TysiaSelectOneGhostLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostLabel`}
/>
<TysiaSelectOneGhostArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneGhostContent>
)}
</TysiaSelectOneGhost>
{children}
</React.Fragment>)
}